import type { Stop } from '#domain/Stop.ts';
import { apiV2Root } from '#store/apiV2Root.ts';

import { mapStop, mapStopToUpdateStop } from './adapters/stopAdapter.ts';
import { type ApiUpdateStop, apiSchema } from './model/types.ts';
import { validateWarn } from './validateZodHelper.ts';

const url = '/stops';
const TAGS = ['TOURS', 'ORDERS'];

export const stopApiSlice = apiV2Root.injectEndpoints({
    endpoints: build => ({
        updateStop: build.mutation<Stop, { id: string; stop: ApiUpdateStop }>({
            query: ({ id, stop }) => ({
                url: `${url}/${id}`,
                method: 'PATCH',
                body: JSON.stringify(stop),
            }),
            invalidatesTags: TAGS,
            transformResponse: (response, meta, arg) => mapStop(validateWarn(apiSchema.BaseStop)(response, meta, arg)),
        }),
    }),
});

export const { useUpdateStopMutation } = stopApiSlice;
export { mapStopToUpdateStop };
